import { Box } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { GatsbyImage } from 'gatsby-plugin-image'
import Slider from 'react-slick'
import Suisse from '../../frontend-lib/typhograpy/Suisse'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import './trustedBy.css'

export function TrustedBy({ trustedByImagesData }) {
  const { t } = useTranslation()

  const settings = {
    dots: false,
    infinite: true,
    speed: 7000,
    cssEase: 'linear',
    accessibility: false,
    pauseOnHover: false,
    autoplay: true,
    autoplaySpeed: 0,
    slidesToShow: 6,
    slidesToScroll: 1,
    variableWidth: true,
  }

  return (
    <Box
      sx={{
        backgroundColor: 'grey.6',
        height: '88px',
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
      }}
    >
      <Box
        sx={{
          minWidth: '167px',
          minHeight: '88px',
          display: { xl: 'flex', xs: 'none' },
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          borderRight: '1px solid rgba(31, 36, 45, 0.1)',
        }}
      >
        <Suisse size={14} color="grey.1">
          {t('trustedBy.title')}
        </Suisse>
      </Box>
      <Box sx={{ width: '100%', overflow: 'hidden' }}>
        <Slider {...settings}>
          {[1, 2].map((position) =>
            trustedByImagesData.map((image) => (
              <Box>
                <Box
                  key={`${position}${image.name}`}
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: '88px',
                  }}
                >
                  <GatsbyImage
                    alt={image.name}
                    image={image.logo.gatsbyImage}
                  />
                </Box>
              </Box>
            ))
          )}
        </Slider>
      </Box>
    </Box>
  )
}
